import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb, Button } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { Link } from 'react-router-dom';
import { notification } from 'antd';

import ReleaseForm from './components/ReleaseForm';

import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import { ReleaseDetailsQuery, UpdateReleaseMutation, UpdateCommentMutation, DeleteCommentMutation, CreateModelTagMutation } from './queries';

class EditRelease extends Component {
  constructor(props) {
    super(props);

    this.state = { deleting: false, deleteError: null };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.deleteComment = this.deleteComment.bind(this);
    this.handleTagCreate = this.handleTagCreate.bind(this);
  }

  handleSubmit({ hasStringPrice, ...data }) {
    this.setState({ deleteError: null });
    const { client, match, push } = this.props;
    const objectId = match.params.id;

    const commentsList = Array.from(data.comments)
    commentsList.forEach(comment => 
      client.mutate({ mutation: UpdateCommentMutation, variables: { id: comment._id, update: comment }, })
    )

    return client.mutate({ mutation: UpdateReleaseMutation, variables: { id: objectId, update: data }, })
      .then(() => push('/releases'))
      .catch(parseFormErrors);
  }

  handleDelete() {
    this.setState({ deleting: true, deleteError: null });
    const { client, match, push } = this.props;
    const objectId = match.params.id;
    return client.mutate({
      mutation: UpdateReleaseMutation,
      variables: { id: objectId, update: { isDeleted: true, featured: false } },
    })
      .then(() => push('/releases'))
      .catch(error => this.setState({
        deleting: false, deleteError: error.message,
      }));
  }

  deleteComment(id) {
    const { client } = this.props;
    return client.mutate({ mutation: DeleteCommentMutation, variables: { id }})
  }


  async handleTagCreate(newTagWord) {
    const { client, data: { refetch } } = this.props;

    let newTag = null

    await client.mutate({
      mutation: CreateModelTagMutation,
      variables: { keyword: { title: newTagWord } },
    })
    .then((response) => {
      refetch();
      newTag = response.data.createModelTag
    })
    .catch(error => {
      if (error.message.endsWith("Validation failed")) {
        return notification.error({ message: "Tag is already exists" });
      }
      notification.error(error);
    });

    return newTag
  }

  render() {
    const { role } = this.props.user;
    const { Release, ModelBrands, ModelTags, SneakerModels, Raffles } = this.props.data;
    const { deleting, deleteError } = this.state;

    const deleteButton = (
      <Button ghost disabled={deleting} loading={deleting} onClick={this.handleDelete} type="danger">
        <AntIcon type="delete" />Delete
      </Button>
    );

    const formRelease = {
      ...Release,
      tag: (Release.tag && Release.tag._id) || '',
      brand: (Release.brand && Release.brand._id) || '',
      sneakerModel: (Release.sneakerModel && Release.sneakerModel._id) || '',
      comments: Release.comments.items
    };

    return (
      <div id="edit-release">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/releases">Releases</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Release</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <ReleaseForm
            initialValues={formRelease}
            onSubmit={this.handleSubmit}
            deleteButton={role === 'admin' && deleteButton}
            deleteError={deleteError}
            brands={ModelBrands}
            tags={ModelTags}
            deleteComment={this.deleteComment}
            tagCreateHandler={this.handleTagCreate}
            sneakerModels={SneakerModels}
            raffles={Raffles}
          />
        </div>
      </div>
    );
  }
}

export default withGraphqlData(
  ReleaseDetailsQuery,
  (props) => ({ id: props.match.params.id }),
  'network-only',
)(
  connect(({ auth: user }) => ({ user }), { push })(
    withApollo(EditRelease),
  ),
);
